<template>
  <v-navigation-drawer class="app--drawer" :mini-variant.sync="mini" app v-model="isExpanded" :width="drawWidth">
    <v-toolbar color="primary"> </v-toolbar>

    <vue-perfect-scrollbar class="drawer-menu--scroll" :settings="scrollSettings">
      <v-list dense expand>
        <template v-for="item in menus">
          <!--top-level link-->

          <v-list-tile
            :to="item.name.toLowerCase()"
            :href="item.href"
            ripple="ripple"
            :disabled="item.disabled"
            :target="item.target"
            rel="noopener"
            :key="item.name"
          >
            <v-list-tile-action v-if="item.icon">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>

            <v-list-tile-action v-if="item.subAction">
              <v-icon class="success--text">{{ item.subAction }}</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </template>
      </v-list>
    </vue-perfect-scrollbar>
  </v-navigation-drawer>
</template>

<script>
import menu from '@/api/menu'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
export default {
  name: 'AppDrawer',
  components: {
    VuePerfectScrollbar,
  },
  props: {
    expanded: {
      type: Boolean,
      default: false,
    },
    drawWidth: {
      type: [Number, String],
      default: '260',
    },
  },
  data() {
    return {
      isExpanded: false,
      mini: false,
      menus: menu,
      scrollSettings: {
        maxScrollbarLength: 160,
      },
    }
  },
  computed: {},
  watch: {
    expanded(newVal) {
      this.isExpanded = newVal
    },
  },
  methods: {
    genChildTarget(item, subItem) {
      if (subItem.href) return
      if (subItem.component) {
        return {
          name: subItem.component,
        }
      }
      return { name: `${item.group}/${subItem.name}` }
    },
  },
}
</script>

<style lang="stylus" scoped>
.app--drawer { overflow: hidden; .drawer-menu--scroll { height: calc(100vh - 48px); overflow: auto; } }
</style>
